import { render } from "./inbox-messagearea.vue?vue&type=template&id=52dbde90"
import script from "./inbox-messagearea.vue?vue&type=script&lang=js"
export * from "./inbox-messagearea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__